import { render, staticRenderFns } from "./OrderHoldDelivery.vue?vue&type=template&id=2e5427dc&"
import script from "./OrderHoldDelivery.vue?vue&type=script&lang=ts&"
export * from "./OrderHoldDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports